import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { Checkbox, Group, Radio, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';
import Autoload from '../../../../Autoload';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class ApplyMappingToLegacyTransactionsModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    selectedValue: 'apply_no'
  };
  
  constructor(props) {
    super(props);
  }

  applyToAllPreviousTransactions=()=>{
    const {bankAccountId, newCreatedMappings} = this.props;
    
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + 'Transactions/BankAccount/'+ bankAccountId+ `${newCreatedMappings.length > 0 ? newCreatedMappings.map((newCreatedMapping, index)=> `${index === 0 ? '?transactionMappingIds=' : '&transactionMappingIds='}${newCreatedMapping}`) : ''}`.replace(',', ''),
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handlePutApplyToAllPreviousTransactions',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handlePutApplyToAllPreviousTransactions(response){
    if(response.status && response.statuscode === 200){

    }
    this.props.toggle();
  }
  
  render() {
    const {selectedValue} = this.state;
    const { open, toggle, className, newCreatedMappings, selectedTransaction, renderNewMappings } = this.props;
    
    return (
      <CustomModal
        heading={'Neue Regel anwenden'}
        headingClassName={'apply-mapping-to-legacy-transactions-modal-heading'}
        open={open}
        toggle={() => {
          toggle(false, true);
        }}
        className={`${className}`}
      >
        <Stack>
            <Group>
              <Stack style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>
                {newCreatedMappings?.length > 1 ? <p className='mb-0'>Wollen Sie die neuen Regeln:</p> : <p className='mb-0'>Wollen Sie die neue Regel:</p>}
                <p className='mb-0'>{renderNewMappings()}</p>
                <p className='mb-0'>jetzt auf alle bestehenden Transaktionen mit der IBAN <span style={{fontWeight: 'bold'}}>{selectedTransaction?.counterpartIban} ({selectedTransaction?.counterpartName})</span> anwenden?</p>
                <p className='mb-0'><span style={{fontWeight: 'bold'}}>Hinweis:</span> Durch die Anwendung auf bestehende Transaktionen kann unter Umständen eine große Anzahl an Belegen oder Mietzahlungen erzeugt werden.</p>
              </Stack>
            </Group>
            <Group className='mb-3'>
              <Radio.Group
              value={selectedValue}
              onChange={(value)=> this.setState({selectedValue: value})}>
                <Radio color='#5555FF' value='apply_no' label={'Nein, nur auf zukünftige Transaktionen anwenden.'}/>
                <Radio color='#5555FF' value='apply_yes' label={'Ja, jetzt auf alle bestehende Transaktionen anwenden.'}/>
              </Radio.Group>
            </Group>
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> toggle(false, true)}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Fortfahren'}
                    className='purple-btn'
                    onClick={()=> {
                      toggle(selectedValue === 'apply_yes');
                      // if(selectedValue === 'apply_yes'){
                      //   this.applyToAllPreviousTransactions();
                      // }else{
                      //   toggle();
                      // }
                    }}
                    />
                </div>
            </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default ApplyMappingToLegacyTransactionsModal;
